import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import flashbot from '../../assets/flashbot.png';
import swiftbot from '../../assets/swiftbot.png';
import t300 from '../../assets/robots/t300.png';

import batteryFull from '../../assets/batteryFull.png';
import battery75 from '../../assets/battery75.png';
import battery25 from '../../assets/battery25.png';
import batteryCharging from '../../assets/batteryCharging.png';
import battery0 from '../../assets/battery0.png';
import { getRobotStatusBackgroundColor, getRobotStatusMainColor } from '../../utils/ColourStatus';
import { getRobotImage } from '../../routes/dashboard/mock-robots';
// import { useSelector, useDispatch } from 'react-redux';

interface RobotIconProps {
    robot: {
        name: string;
        status: string;
        battery: number;
        url: string;
    }
}

const RobotIcon: React.FC<RobotIconProps> = ({ robot }) => {
//   const isLegendOn = useSelector((state: any) => state.toggleLegend.isLegendOn);
    
    // const legendOpen = useSelector((state: any) => state.toggleLegend.isLegendOn);
    // useEffect(() => {
    //     customLog('robotIcon', isLegendOn);
    // }, [isLegendOn]);

    const [batteryIcon, setBatteryIcon] = React.useState<string>('');
    const [statusColor, setStatusColor] = React.useState<string>('');
    useEffect(() => {
        setBatteryIcon(getBatteryIcon(robot.battery));
        setStatusColor(getStatusColor(robot.status));
    }, [robot]);

    const getBatteryIcon = (battery: number) => {
        if (battery >= 75) return batteryFull;
        if (battery < 75 && battery >= 40) return battery75;
        if (battery < 40 && battery >= 10) return battery25;
        if (battery < 10 && battery > 0) return battery0;
        return batteryCharging;
    }

    

    const getStatusColor = (status: string) => {
      return getRobotStatusMainColor(status)
    }
    
    const getRobotColor = (status: string) => {
      return {
        backgroundColor: getRobotStatusBackgroundColor(status),
        border: getRobotStatusMainColor(status)
      };
    }

    return (
        <Box sx={{
            zIndex: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
            // border: "3px solid #5FD8FF", 
            border: `3px solid ${getRobotColor(robot.status).border}`,
            borderRadius: '50%',
            position: 'relative',
            width: 40,
            height: 40, 
            backgroundColor: getRobotColor(robot.status).backgroundColor,
            '& img': {
                width: '40px',
                height: 'auto', 
            },
        }}>
            <div style={{
                position: 'absolute', 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
            }}>
                <img src={robot.url} alt="Robot" />
                {/* {isLegendOn && <img src={batteryIcon} alt="Battery" style={{ position: 'absolute', top: -40, left: '50%', transform: 'translateX(-50%)', width: 30, height: 30 }} /> } */}
                <Typography
                    variant="subtitle2"
                    sx={{
                        color: 'black',
                        fontSize: '14px',
                        mt: 0.5,
                        textAlign: 'center',
                        position: 'absolute',
                        top: 70,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        // ml: -1
                        minWidth: '100%',
                        mx: 'auto'
                    }}
                >
                    {robot?.name}
                </Typography>
                {/* {isLegendOn &&
                <Typography
                    variant="subtitle2"
                    sx={{
                        color: statusColor,
                        fontSize: '12px',
                        mt: 0.5,
                        textAlign: 'center',
                        position: 'absolute',
                        top: 90,
                        width: '60px',
                        ml: -0.6,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        
                    }}
                >
                    {robot?.status[0].toUpperCase() + robot?.status.slice(1).toLowerCase()}
                </Typography>
                } */}

            </div>

            <Box sx={{
                position: 'absolute',
                top: -10, 
                left: '50%',
                width: 0,
                height: 0,
                borderLeft: '10px solid transparent', 
                borderRight: '10px solid transparent', 
                borderBottom: `10px solid ${getRobotColor(robot.status).border}`,
                transform: 'translateX(-50%)',
            }} 
            />
        </Box>
    );
}

export default RobotIcon;
